import { AdvancedReportsQueryCategories } from '../constants/advanced-reports-query-categories';

export const createCompareCacheKey = (
  queryCategory: AdvancedReportsQueryCategories
): string => `${queryCategory}_Compare`;
